import { RSAA, RSAAction } from 'redux-api-middleware';

import { ChangePasswordPayload, ResetPasswordPayload, UpdateUserPayload } from './user.types';
import * as types from './userActionTypes';

export const createUser = (body: any): RSAAction<string, string, string> => {
  const formData = new FormData();

  formData.append(
    'request-data',
    new Blob([JSON.stringify({ ...body, attachment: undefined })], {
      type: 'application/json',
    }),
  );

  if (body.attachment) {
    formData.append('attachment', body.attachment);
  }

  return {
    [RSAA]: {
      body: formData,
      credentials: 'same-origin',
      endpoint: 'register',
      headers: () => ({}),
      method: 'POST',
      skipAuth: true,
      types: [types.CREATE_NEW_USER_REQUEST, types.CREATE_NEW_USER_SUCCESS, types.CREATE_NEW_USER_FAILURE],
    },
  };
};

export const fetchUserInfo = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: 'me',
    method: 'GET',
    types: [types.FETCH_USER_INFO_REQUEST, types.FETCH_USER_INFO_SUCCESS, types.FETCH_USER_INFO_FAILURE],
  },
});

export const updateUserInfo = (body: UpdateUserPayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: `me`,
    method: 'PUT',
    types: [types.UDPATE_USER_INFO_REQUEST, types.UDPATE_USER_INFO_SUCCESS, types.UDPATE_USER_INFO_FAILURE],
  },
});

export const resetPassword = (body: ResetPasswordPayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    credentials: 'same-origin',
    endpoint: 'user/password/reset',
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    skipAuth: true,
    types: [types.RESET_PASSWORD_REQUEST, types.RESET_PASSWORD_SUCCESS, types.RESET_PASSWORD_FAILURE],
  },
});

export const validateToken = (token: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `user/password/reset/${token}`,
    method: 'GET',
    skipAuth: true,
    types: [types.VALIDATE_TOKEN_REQUEST, types.VALIDATE_TOKEN_SUCCESS, types.VALIDATE_TOKEN_FAILURE],
  },
});

export const changePassword = (body: ChangePasswordPayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: `user/password/reset/${body.token}`,
    method: 'PUT',
    skipAuth: true,
    types: [types.CHANGE_PASSWORD_REQUEST, types.CHANGE_PASSWORD_SUCCESS, types.CHANGE_PASSWORD_FAILURE],
  },
});

export const activateEmail = (token: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `activate/${token}`,
    method: 'GET',
    skipAuth: true,
    types: [types.ACTIVATE_EMAIL_REQUEST, types.ACTIVATE_EMAIL_SUCCESS, types.ACTIVATE_EMAIL_FAILURE],
  },
});
